import{Z as o,d as s}from"./p-Crkt8vaO.js";const t=o;const r=s;export{t as ZprTooltip,r as defineCustomElement};
//# sourceMappingURL=zpr-tooltip.js.map